import React, { useEffect } from "react";

export default function SEO({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name='${name}']`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setOG = (property, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property='${property}']`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", property); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setOG("og:title", title);
    setOG("og:description", description);
    setOG("og:type", "website");
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
  return null;
}
